
import React from 'react';
import '../css-coding/privacy.css';

const PrivacyPolicy = () => {
  return (
   <div className="terms-container">
    <div id="terms-of-services">
      <div className="terms-heading">Terms & Conditions.</div>
      <div className="terms-updated"> <span className="grey-text">Last Updated</span> <br />
  <span className="black-text">Jan 01, 2026</span></div>
      <div className ="terms-right">
      <div className="terms-section-title">1. Introduction</div>
      <div className="terms-text">
        Welcome to The Growth Secret Media ("Company," "we," "our," or "us"). These Terms and Conditions
        ("Terms") govern your use of our website (thegrowthsecret.in) and services. By accessing or using
        our services, you agree to be bound by these Terms.
      </div>

      <div className="section">
        <div className="section-title-p">Company Details:</div>
        <ul className="details-list">
          <li><strong>Business Name:</strong> The Growth Secret Media</li>
          <li><strong>Registration:</strong> MSME Registered</li>
          <li><strong>Location:</strong> Coimbatore, Tamil Nadu, India</li>
          <li><strong>Contact:</strong> contact@thegrowthsecret.in</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">2. Services Offered</div>
        <div className="section-text">
          We provide professional video editing and content creation services including:
        </div>
        <ul className="bullet-list">
          <li>Reels Editing (Basic, Intermediate, Advanced)</li>
          <li>Long-form Video Editing (YouTube & Corporate)</li>
          <li>Graphic Design Services</li>
          <li>Personal Branding & Commercial Shoots</li>
          <li>Motion Graphics and Visual Effects</li>
          <li>Content Strategy and Social Media Management</li>
          <li>Performance Marketing</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">3. Service Agreement and Project Scope</div>
        <div className="subheading">Project Initiation</div>
        <ul className="bullet-list">
          <li>All projects require a consultation call to define scope and expectations</li>
          <li>Written confirmation of project details, timeline, and pricing must be agreed upon before work begins</li>
          <li>Any changes to the original scope will require separate discussion and may incur additional charges</li>
        </ul>

        <div className="subheading">Client Responsibilities</div>
        <ul className="bullet-list">
          <li>Provide all necessary raw footage, assets, and project requirements 2-3 days in advance</li>
          <li>Respond promptly to revision requests and feedback queries</li>
          <li>Make timely payments as per agreed schedule</li>
          <li>Provide clear, constructive feedback during review phases</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">4. Payment Terms</div>
        <div className="subheading">Payment Structure</div>
        <ul className="details-list">
          <li><strong>Advance Payment:</strong> 50% advance payment required before project initiation</li>
          <li><strong>Final Payment:</strong> Remaining 50% due upon project completion and before final file delivery</li>
        </ul>
      </div>

      <div className="section">
        <div className="subheading">Refund Policy</div>
        <ul className="bullet-list">
          <li>If client cancels before work begins: Full refund minus processing fees</li>
          <li>If project is less than 30% complete: 70% refund after deducting completed work value</li>
          <li>If project is 70% or more complete: No refund applicable</li>
          <li>Refund processing time: 7–14 business days</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">5. Revision Policy</div>

        <div className="subheading">Included Revisions</div>
        <ul className="bullet-list">
          <li><strong>Major Changes:</strong> Up to 2 major revisions (restructuring, theme changes, section additions/removals)</li>
          <li><strong>Minor Corrections:</strong> Up to 3 minor corrections (text changes, color adjustments, small edits)</li>
        </ul>

        <div className="subheading">Additional Revisions</div>
        <ul className="bullet-list">
          <li>Revisions beyond the included limits will be charged separately</li>
          <li>Additional revision rates will be communicated based on complexity</li>
          <li>Rush revisions may incur premium charges</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">6. Delivery and Timeline</div>

        <div className="subheading">Standard Delivery Times</div>
        <ul className="bullet-list">
          <li><strong>Basic Reel Editing:</strong> 2–3 business days</li>
          <li><strong>Advanced Reel Editing:</strong> 3–5 business days</li>
          <li><strong>Long-form Videos:</strong> 5–7 business days</li>
          <li><strong>Rush Delivery:</strong> Available at premium rates (50% additional charge)</li>
        </ul>

        <div className="subheading">Delivery Method</div>
        <ul className="bullet-list">
          <li>Final files delivered via WhatsApp, or cloud storage links</li>
          <li>High-resolution files provided in agreed formats</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">7. Intellectual Property Rights</div>
        <div className="subheading">Client Ownership</div>
      </div>

     
      <ul className="bullet-list">
        <li>Clients retain full ownership of final edited videos upon complete payment</li>
        <li>Original footage and content provided by clients remain their property</li>
      </ul>

      {/* Company Rights */}
      <div className="subheading">Company Rights</div>
      <ul className="bullet-list">
        <li>The Growth Secret Media retains the right to showcase completed work in portfolio and marketing materials</li>
        <li>Company branding and watermarks may appear on preview versions</li>
        <li>Client names and project details used for marketing purposes unless specifically requested otherwise</li>
      </ul>

      {/* Confidentiality */}
      <div className="subheading">Confidentiality</div>
      <ul className="bullet-list">
        <li>We maintain strict confidentiality of all client projects and business information</li>
        <li>Non-disclosure agreements available upon request for sensitive projects</li>
      </ul>

      {/* Limitation of Liability */}
      <div className="section">
        <div className="section-heading">8. Limitation of Liability</div>

        <div className="subheading">Service Limitations</div>
        <ul className="bullet-list">
          <li>We are not liable for delays caused by client unresponsiveness or late asset submission</li>
          <li>Technical issues beyond our control (software crashes, hardware failures, power cut) may affect delivery times</li>
          <li>We are not responsible for content compliance with platform-specific guidelines post-delivery</li>
           
        </ul>

        <div className="subheading">Liability Cap</div>
        <ul className="bullet-list">
          <li>Our total liability is limited to the amount paid for the specific project</li>
          <li>We are not liable for indirect, consequential, or punitive damages</li>
         
        </ul>
      </div>

      {/* Termination */}
      <div className="section">
        <div className="section-heading">9. Termination</div>

        <div className="subheading">Client Termination</div>
        <ul className="bullet-list">
          <li>Clients may terminate projects with written notice</li>
          <li>Refunds calculated based on work completed as per our refund policy</li>
        </ul>

        <div className="subheading">Company Termination</div>
        <ul className="bullet-list">
        <li>We reserve the right to terminate service for non-payment, abusive behavior, or violation of terms</li>
        <li>In case of termination by company, prorated refunds will be provided</li>
      </ul>

       <div className="section">
        <div className="section-heading">10. Dispute Resolution</div>
        <ul className="bullet-list">
          <li>All disputes will be resolved through good-faith negotiations</li>
          <li>If unresolved, disputes will be subject to arbitration in Coimbatore, Tamil Nadu</li>
          <li>Indian law governs these terms and conditions</li>
        </ul>
      </div>
      </div>
      </div>
      </div>
<div className="terms-container">

     
     

      {/* Privacy Policy */}
      <div className="sections">
        <div id="privacy-policy">
        <div className="terms-heading-2">Privacy Policy.</div>
      </div>
         <div className ="terms-right">
      <div className="sections">
        <div className="section-heading">1. Information We Collect</div>

        <div className="subheading">Personal Information</div>
        <div className="section-text">We collect information you provide directly to us:</div>
        <ul className="bullet-list">
          <li><strong>Contact Information:</strong> Name, email address, phone number, business details</li>
          <li><strong>Project Information:</strong> Video content, brand assets, creative briefs</li>
          <li><strong>Payment Information:</strong> Billing details, transaction records</li>
          <li><strong>Communication Records:</strong> WhatsApp messages, emails, call recordings (with consent)</li>
        </ul>

        <div className="subheading">Automatically Collected Information</div>
        <ul className="bullet-list">
          <li><strong>Website Usage:</strong> IP address, browser type, pages visited, time spent</li>
          <li><strong>Device Information:</strong> Device type, operating system, unique device identifiers</li>
          <li><strong>Cookies:</strong> We use cookies to improve user experience and website functionality</li>
        </ul>
      </div>

      <div className="section">
        <div className="section-heading">2. How We Use Your Information</div>

        <div className="subheading">Service Delivery</div>
        <ul className="bullet-list">
          <li>Process and complete your video editing projects</li>
          <li>Communicate project updates and gather feedback</li>
          <li>Provide customer support and technical assistance</li>
        </ul>
      </div>

      {/* How We Use Your Information (continued) */}
      <div className="subheading">Business Operations</div>
      <ul className="bullet-list">
        <li>Process payments and maintain financial records</li>
        <li>Improve our services based on client feedback</li>
        <li>Conduct market research and analytics</li>
        <li>Maintain legal compliance and business records</li>
      </ul>

      <div className="subheading">Marketing Communications</div>
      <ul className="bullet-list">
        <li>Send newsletters and service updates (with consent)</li>
        <li>Share portfolio examples featuring your work (with permission)</li>
        <li>Promote our services using client testimonials (anonymized if requested)</li>
      </ul>

      {/* Information Sharing and Disclosure */}
      <div className="section">
        <div className="section-heading">3. Information Sharing and Disclosure</div>

        <div className="subheading">Limited Sharing</div>
        <div className="section-text">
          We do not sell, trade, or rent your personal information. We may share
          information only in these circumstances:
        </div>
        <ul className="bullet-list">
          <li><strong>Service Providers:</strong> Trusted third-party tools (payment processors, cloud storage, project management tools)</li>
          <li><strong>Legal Requirements:</strong> When required by law, court order, or government request</li>
          <li><strong>Business Transfer:</strong> In case of merger, acquisition, or sale of business assets</li>
          <li><strong>Consent:</strong> When you explicitly authorize information sharing</li>
        </ul>

        <div className="subheading">Project Confidentiality</div>
        <ul className="bullet-list">
          <li>Your video content and creative materials are kept strictly confidential</li>
          <li>Access limited to assigned project team members only</li>
          <li>Secure file handling and storage protocols maintained</li>
        </ul>
      </div>

      {/* Data Security */}
      <div className="section">
        <div className="section-heading">4. Data Security</div>
        <div className="subheading">Security Measures</div>
        <ul className="bullet-list">
          <li>Encrypted data transmission and secure cloud storage</li>
          <li>Regular security audits and system updates</li>
          <li>Access controls and employee training on data protection</li>
          <li>Secure backup systems for all client projects</li>
        </ul>
      </div>

      <div className="section">

      {/* Data Retention */}
      <div className="subheading">Data Retention</div>
      <ul className="bullet-list">
        <li>Project files retained for 15 days post-delivery for revision purposes</li>
        <li>Client contact information maintained for ongoing business relationship</li>
        <li>Financial records kept as per legal requirements</li>
        <li>Data deletion available upon written request</li>
      </ul>

      {/* Your Rights and Choices */}
      <div className="section">
        <div className="section-heading">5. Your Rights and Choices</div>

        <div className="subheading">Access and Control</div>
        <ul className="bullet-list">
          <li><strong>Access:</strong> Request copies of your personal information</li>
          <li><strong>Correction:</strong> Update or correct inaccurate information</li>
          <li><strong>Deletion:</strong> Request deletion of your personal data (subject to legal requirements)</li>
          <li><strong>Portability:</strong> Receive your data in a portable format</li>
        </ul>

        <div className="subheading">Communication Preferences</div>
        <ul className="bullet-list">
          <li><strong>Opt-out:</strong> Unsubscribe from marketing communications anytime</li>
          <li><strong>Consent Withdrawal:</strong> Withdraw consent for data processing where applicable</li>
          <li><strong>Privacy Settings:</strong> Control how your information is used for marketing</li>
        </ul>
      </div>

      {/* Cookies and Tracking */}
      <div className="section">
        <div className="section-heading">6. Cookies and Tracking</div>

        <div className="subheading">Cookie Usage</div>
        <div className="section-text">Our website uses cookies for:</div>
        <ul className="bullet-list">
          <li><strong>Essential Functions:</strong> Website operation and security</li>
          <li><strong>Analytics:</strong> Understanding website usage and improving user experience</li>
          <li><strong>Marketing:</strong> Displaying relevant content and advertisements</li>
        </ul>

        <div className="subheading">Cookie Management</div>
        <ul className="bullet-list">
          <li>You can control cookie settings through your browser</li>
          <li>Disabling cookies may affect website functionality</li>
          <li>Third-party cookies subject to respective privacy policies</li>
        </ul>
      </div>

      <div className="section">

      {/* 7. Third-Party Services */}
      <div className="section">
        <div className="section-heading">7. Third-Party Services</div>
        <div className="section-text">
          We use trusted third-party services that may have access to your information:
        </div>
        <div className="bullet-list">
          <li><strong>Payment Processors:</strong> For secure transaction processing</li>
          <li><strong>Cloud Storage:</strong> Google Drive, Dropbox for file storage and sharing</li>
          <li> <strong>Communication Tools:</strong> WhatsApp Business, email services</li>
          <li> <strong>Analytics:</strong> Website traffic and user behavior analysis</li>
        </div>
      </div>

      {/* 8. International Data Transfers */}
      <div className="section">
        <div className="section-heading">8. International Data Transfers</div>
        <div className="bullet-list">
          <li>Primary data processing occurs within India</li>
           <li>Some third-party services may store data internationally</li>
           <li>Adequate protection measures ensured for international transfers</li>
          <li>EU residents have additional rights under GDPR</li>
        </div>
      </div>

      {/* 9. Children's Privacy */}
      <div className="section">
        <div className="section-heading">9. Children's Privacy</div>
        <div className="bullet-list">
          <li>Our services are not intended for children under 13</li>
         <li>We do not knowingly collect information from children</li>
          <li>Parents/guardians should contact us if a child has provided information</li>
          <li>Immediate deletion of children's data upon notification</li>
        </div>
      </div>

      {/* 10. Updates to This Policy */}
      <div className="section">
        <div className="section-heading">10. Updates to This Policy</div>
        <div className="bullet-list">
          <li>Privacy policy may be updated periodically</li>
         <li>Material changes will be communicated via email or website notice</li>
          <li>Continued use of services constitutes acceptance of updated policy</li>
          <li>Previous versions available upon request</li>
        </div>
      </div>

      {/* 11. Contact Information */}
      <div className="section">
        <div className="section-heading">11. Contact Information</div>
        <div className="section-text">
          For questions about these Terms & Conditions or Privacy Policy:
        </div>
        <div className="contact-block">
          <div className="section-heading">The Growth Secret Media</div>
          <div className="section-text"><strong>Email:</strong> contact@thegrowthsecret.in</div>
          <div className="section-text"><strong>Website:</strong> thegrowthsecret.in</div>
          <div className="section-text"><strong>Address:</strong> Coimbatore, Tamil Nadu, India</div>
          <div className="section-text"><strong>Phone:</strong> 6382765055</div>
        </div>
        <div className="section-text"><strong>Data Protection Officer:</strong> contact@thegrowthsecret.in</div>
      </div>
      </div>

<div className="privacy-footer">
  <div className="response-time">
    <strong>Response Time:</strong> We aim to respond to all privacy-related inquiries within 48 hours.
  </div>

  <div className="dates">
    <p><strong>Effective Date:</strong> 01.01.2026</p>
    <p><strong>Last Updated:</strong> 01.01.2026</p>
  </div>

  <div className="agreement-note">
    By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions and Privacy Policy.
  </div>
</div>
    </div>
</div>
    </div>

    </div>
    </div>
    

    
  );
};

export default PrivacyPolicy;
